import PropTypes from 'prop-types';

export default {
  projectId: PropTypes.number,
  id: PropTypes.number,
  status: PropTypes.string,
  uid: PropTypes.string,
  projectTitle: PropTypes.string,
  deviceSerial: PropTypes.string,
  measurementTimestamp: PropTypes.string
};
